"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTC = [
    { deviceName: 'HTC One X10', brandName: 'HTC', deviceCode: 'HTCOneX10' },
    { deviceName: 'HTC One M9', brandName: 'HTC', deviceCode: 'HTCOneM9' },
    { deviceName: 'HTC Desire 820G PLUS', brandName: 'HTC', deviceCode: '820G PLUS' }
];
//# sourceMappingURL=htc.js.map